import { Routes } from "@angular/router";
import { QuotationRequestPageComponent } from "./quotation-request-page/quotation-request-page.component";

export const QUOTATION_RQQUEST_ROUTES: Routes = [
  { path: "", component: QuotationRequestPageComponent },
];
